import React from "react";
import moment from "moment";
import {
    Document,
    Page,
    Text,
    View,
    StyleSheet,
    PDFDownloadLink,
} from "@react-pdf/renderer";


// FORMAT NUMBER
const formatAmount = (amount) => {
    return (Number(amount) || 0).toLocaleString("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

// PDF STYLES
const styles = StyleSheet.create({
    page: {
        width: "100%",
        minHeight: "100%",
        backgroundColor: "#ffffff",

        paddingTop: 38,
        paddingBottom: 32,
        paddingLeft: 40,
        paddingRight: 40,

        fontFamily: "Helvetica",
        color: "#222222",

        position: "relative",
    },

    // HEADER

    slipHeader: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
    },

    companyInfo: {
        flex: 1,
        paddingRight: 15,
        minWidth: 0,
    },

    companyText: {
        width: 350,
        maxWidth: 350,
    },

    companyName: {
        fontSize: 14,
        fontWeight: "bold",
        color: "#303030",
        lineHeight: 1.15,
    },

    companyAddress: {
        marginTop: 4,
        fontSize: 9,
        color: "#666666",
        lineHeight: 1.25,
    },

    monthSection: {
        width: 145,
        minWidth: 145,
        alignItems: "flex-end",
    },

    monthLabel: {
        fontSize: 9.5,
        color: "#666666",
        textAlign: "right",
    },

    monthValue: {
        fontSize: 13,
        fontWeight: "bold",
        color: "#111111",
        marginTop: 2,
        textAlign: "right",
    },

    headerLine: {
        width: "100%",
        borderBottomWidth: 1,
        borderBottomColor: "#bfc5ca",
        marginTop: 13,
    },

    // ========================================================
    // EMPLOYEE SUMMARY
    // ========================================================

    summaryWrapper: {
        flexDirection: "row",
        width: "100%",
        marginTop: 16,
        minHeight: 155,
    },

    employeeSummary: {
        flex: 1,
        minWidth: 0,
        paddingTop: 3,
        paddingRight: 20,
    },

    summaryTitle: {
        fontSize: 10,
        fontWeight: "bold",
        color: "#555555",
        marginBottom: 9,
    },

    summaryRow: {
        flexDirection: "row",
        alignItems: "flex-start",
        width: "100%",
        marginBottom: 8,
        minHeight: 16,
    },

    summaryLabel: {
        width: 100,
        minWidth: 100,
        fontSize: 10,
        color: "#666666",
    },

    summaryColon: {
        width: 12,
        minWidth: 12,
        fontSize: 10,
        color: "#666666",
    },

    summaryValue: {
        flex: 1,
        minWidth: 0,
        maxWidth: 210,

        fontSize: 10,
        color: "#222222",

        lineHeight: 1.25,
    },

    // ========================================================
    // NET PAY CARD
    // ========================================================

    netPayCard: {
        width: 250,
        height: 135,

        borderWidth: 1,
        borderColor: "#bcc8d3",

        borderRadius: 10,

        overflow: "hidden",
    },

    netPayMain: {
        flexDirection: "row",

        paddingTop: 15,
        paddingBottom: 12,
        paddingLeft: 18,
        paddingRight: 18,

        backgroundColor: "#edfff2",

        borderTopLeftRadius: 9,
        borderTopRightRadius: 9,
    },

    netPayBorder: {
        width: 3,
        height: 29,

        borderRadius: 3,

        backgroundColor: "#55c96f",

        marginRight: 9,
    },

    netPayContent: {
        flex: 1,
        minWidth: 0,
    },

    netPayAmount: {
        fontSize: 18,
        fontWeight: "bold",
        lineHeight: 1,
        color: "#111111",
    },

    netPayLabel: {
        marginTop: 5,
        fontSize: 10,
        color: "#66836e",
    },

    netPayDivider: {
        borderBottomWidth: 1,
        borderBottomColor: "#c3cbd1",
        borderStyle: "dotted",

        marginLeft: 18,
        marginRight: 18,
    },

    daysRow: {
        flexDirection: "row",
        alignItems: "center",

        paddingTop: 6,
        paddingLeft: 18,
        paddingRight: 18,
    },

    daysLabel: {
        width: 125,
        minWidth: 125,

        fontSize: 10,
        color: "#666666",
    },

    daysColon: {
        width: 12,
        minWidth: 12,

        fontSize: 10,
        color: "#666666",
    },

    daysValue: {
        flex: 1,
        minWidth: 0,

        fontSize: 10,
        color: "#222222",
    },

    // ========================================================
    // INCOME / DEDUCTIONS
    // ========================================================

    incomeSection: {
        flexDirection: "row",
        width: "100%",

        borderWidth: 1,
        borderColor: "#c9d2dc",

        borderRadius: 10,

        paddingTop: 12,
        paddingBottom: 0,
        paddingLeft: 12,
        paddingRight: 12,

        marginTop: 2,

        overflow: "hidden",
    },

    incomeColumn: {
        width: "50%",
        flexDirection: "column",
        paddingBottom: 0,

        minWidth: 0,
    },

    incomeColumnLeft: {
        paddingRight: 10,
    },

    incomeColumnRight: {
        paddingLeft: 10,
    },

    tableHeader: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },

    tableHeaderTitle: {
        fontSize: 10,
        fontWeight: "bold",
        color: "#444444",
    },

    tableHeaderAmount: {
        fontSize: 10,
        fontWeight: "bold",
        color: "#444444",
        textAlign: "right",
    },

    tableHeaderLine: {
        borderBottomWidth: 1,
        borderBottomColor: "#c5cdd4",
        borderStyle: "dotted",

        marginTop: 7,
        marginBottom: 1,
    },

    salaryRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",

        minHeight: 27,

        paddingTop: 2,
        paddingBottom: 2,
    },

    salaryDescription: {
        flex: 1,
        minWidth: 0,

        paddingRight: 6,

        fontSize: 10,
        color: "#222222",

        lineHeight: 1.15,
    },

    salaryAmount: {
        width: 100,
        minWidth: 100,

        fontSize: 10,
        color: "#222222",

        textAlign: "right",
    },

    totalRowLeft: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",

        marginTop: 4,

        marginLeft: -12,
        marginRight: -10,

        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 12,
        paddingRight: 10,

        backgroundColor: "#f6f7f9",

        borderBottomLeftRadius: 9,
    },

    totalRowRight: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",

        marginTop: 4,

        marginLeft: -10,
        marginRight: -12,

        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 10,
        paddingRight: 12,

        backgroundColor: "#f6f7f9",

        borderBottomRightRadius: 9,
    },

    totalText: {
        fontSize: 10,
        fontWeight: "bold",
        color: "#222222",
    },

    totalAmount: {
        width: 100,

        fontSize: 10,
        fontWeight: "bold",
        color: "#222222",

        textAlign: "right",
    },

    // ========================================================
    // TOTAL NET PAYABLE
    // ========================================================

    totalPayableBox: {
        flexDirection: "row",
        width: "100%",

        borderWidth: 1,
        borderColor: "#c9d2dc",

        borderRadius: 9,

        overflow: "hidden",

        marginTop: 18,

        minHeight: 48,
    },

    payableLeft: {
        flex: 1,

        justifyContent: "center",

        paddingTop: 7,
        paddingBottom: 7,
        paddingLeft: 14,
        paddingRight: 14,

        minWidth: 0,
    },

    payableTitle: {
        fontSize: 10,
        fontWeight: "bold",
        color: "#222222",
    },

    payableSubtitle: {
        marginTop: 2,

        fontSize: 9,
        color: "#666666",
    },

    payableAmount: {
        width: 125,

        alignItems: "center",
        justifyContent: "center",

        backgroundColor: "#edfff2",

        fontSize: 11,
        fontWeight: "bold",
        color: "#111111",

        textAlign: "center",

        borderTopRightRadius: 8,
        borderBottomRightRadius: 8,
    },

    // ========================================================
    // AMOUNT WORDS
    // ========================================================

    amountWords: {
        width: "100%",

        marginTop: 14,

        textAlign: "right",

        fontSize: 9,
        color: "#666666",

        lineHeight: 1.2,
    },

    amountWordsStrong: {
        color: "#111111",
        fontWeight: "500px",
    },

    // ========================================================
    // FOOTER
    // ========================================================

    footer: {
        position: "absolute",

        bottom: 15,

        left: 40,
        right: 40,

        paddingTop: 8,

        borderTopWidth: 1,
        borderTopColor: "#c0c7cd",

        textAlign: "center",

        fontSize: 8,
        color: "#777777",
    },

    footerStrong: {
        fontWeight: "bold",
    },
});


// SALARY PDF DOCUMENT


const SalarySlipPDF = ({ data }) => {
    const formattedPayPeriod = data.payPeriod
        ? moment(`${data.payPeriod}-01`).format("MMMM YYYY")
        : "-";

    const formattedPayDate = data.payDate
        ? moment(data.payDate).format("DD/MM/YYYY")
        : "-";

    const earnings =
        data.earnings?.filter(
            (item) => item.description?.trim()
        ) || [];

    const deductions =
        data.deductions?.filter(
            (item) => item.description?.trim()
        ) || [];

    // Keep both columns the same number of rows
    const maxSalaryRows = Math.max(
        earnings.length,
        deductions.length
    );

    return (
        <Document
            title={`Salary Slip - ${data.employeeName || "Employee"}`}
            author="Kipinn"
            subject="Salary Slip"
        >
            <Page
                size="A4"
                orientation="portrait"
                style={styles.page}
            >
                {/* ==================================================
                    HEADER
                ================================================== */}

                <View style={styles.slipHeader}>
                    <View style={styles.companyInfo}>
                        <View style={styles.companyText}>
                            <Text style={styles.companyName}>
                                {data.companyName || "Company Name"}
                            </Text>

                            <Text style={styles.companyAddress}>
                                {data.address || ""}

                                {data.city
                                    ? `, ${data.city}`
                                    : ""}

                                {data.pincode
                                    ? `, ${data.pincode}`
                                    : ""}
                            </Text>
                        </View>
                    </View>

                    <View style={styles.monthSection}>
                        <Text style={styles.monthLabel}>
                            Payslip For the Month
                        </Text>

                        <Text style={styles.monthValue}>
                            {formattedPayPeriod}
                        </Text>
                    </View>
                </View>

                <View style={styles.headerLine} />

                {/* ==================================================
                    EMPLOYEE SUMMARY
                ================================================== */}

                <View style={styles.summaryWrapper}>
                    <View style={styles.employeeSummary}>
                        <Text style={styles.summaryTitle}>
                            EMPLOYEE SUMMARY
                        </Text>

                        {/* EMPLOYEE NAME */}
                        <View style={styles.summaryRow}>
                            <Text style={styles.summaryLabel}>
                                Employee Name
                            </Text>

                            <Text style={styles.summaryColon}>
                                :
                            </Text>

                            <Text style={styles.summaryValue}>
                                {data.employeeName || "-"}
                            </Text>
                        </View>

                        {/* EMPLOYEE ID */}
                        <View style={styles.summaryRow}>
                            <Text style={styles.summaryLabel}>
                                Employee ID
                            </Text>

                            <Text style={styles.summaryColon}>
                                :
                            </Text>

                            <Text style={styles.summaryValue}>
                                {data.employeeId || "-"}
                            </Text>
                        </View>

                        {/* PAY PERIOD */}
                        <View style={styles.summaryRow}>
                            <Text style={styles.summaryLabel}>
                                Pay Period
                            </Text>

                            <Text style={styles.summaryColon}>
                                :
                            </Text>

                            <Text style={styles.summaryValue}>
                                {formattedPayPeriod}
                            </Text>
                        </View>

                        {/* PAY DATE */}
                        <View style={styles.summaryRow}>
                            <Text style={styles.summaryLabel}>
                                Pay Date
                            </Text>

                            <Text style={styles.summaryColon}>
                                :
                            </Text>

                            <Text style={styles.summaryValue}>
                                {formattedPayDate}
                            </Text>
                        </View>
                    </View>

                    {/* ==================================================
                        NET PAY
                    ================================================== */}

                    <View style={styles.netPayCard}>
                        <View style={styles.netPayMain}>
                            <View style={styles.netPayBorder} />

                            <View style={styles.netPayContent}>
                                <Text style={styles.netPayAmount}>
                                    Rs. {formatAmount(data.netSalary)}
                                </Text>

                                <Text style={styles.netPayLabel}>
                                    Total Net Pay
                                </Text>
                            </View>
                        </View>

                        <View style={styles.netPayDivider} />

                        <View style={styles.daysRow}>
                            <Text style={styles.daysLabel}>
                                Paid Days
                            </Text>

                            <Text style={styles.daysColon}>
                                :
                            </Text>

                            <Text style={styles.daysValue}>
                                {data.paidDays || 0}
                            </Text>
                        </View>

                        <View style={styles.daysRow}>
                            <Text style={styles.daysLabel}>
                                LOP Days
                            </Text>

                            <Text style={styles.daysColon}>
                                :
                            </Text>

                            <Text style={styles.daysValue}>
                                {data.lossOfPayDays || 0}
                            </Text>
                        </View>
                    </View>
                </View>

                {/* ==================================================
                    INCOME & DEDUCTIONS
                ================================================== */}

                <View style={styles.incomeSection}>
                    {/* INCOME */}
                    <View
                        style={[
                            styles.incomeColumn,
                            styles.incomeColumnLeft,
                        ]}
                    >
                        <View style={styles.tableHeader}>
                            <Text style={styles.tableHeaderTitle}>
                                Income
                            </Text>

                            <Text style={styles.tableHeaderAmount}>
                                AMOUNT
                            </Text>
                        </View>

                        <View style={styles.tableHeaderLine} />

                        {/* {earnings.map((item, index) => (
                            <View
                                key={`earning-${index}`}
                                style={styles.salaryRow}
                            >
                                <Text style={styles.salaryDescription}>
                                    {item.description}
                                </Text>

                                <Text style={styles.salaryAmount}>
                                    Rs. {formatAmount(item.amount)}
                                </Text>
                            </View>
                        ))} */}
                        {Array.from({ length: maxSalaryRows }).map((_, index) => {
                            const item = earnings[index];

                            return (
                                <View
                                    key={`earning-${index}`}
                                    style={styles.salaryRow}
                                >
                                    {item ? (
                                        <>
                                            <Text style={styles.salaryDescription}>
                                                {item.description}
                                            </Text>

                                            <Text style={styles.salaryAmount}>
                                                Rs. {formatAmount(item.amount)}
                                            </Text>
                                        </>
                                    ) : (
                                        <>
                                            <Text style={styles.salaryDescription}>
                                                {" "}
                                            </Text>

                                            <Text style={styles.salaryAmount}>
                                                {" "}
                                            </Text>
                                        </>
                                    )}
                                </View>
                            );
                        })}

                        <View style={styles.totalRowLeft}>
                            <Text style={styles.totalText}>
                                Gross Income
                            </Text>

                            <Text style={styles.totalAmount}>
                                Rs. {formatAmount(data.grossEarnings)}
                            </Text>
                        </View>
                    </View>

                    {/* DEDUCTIONS */}
                    <View
                        style={[
                            styles.incomeColumn,
                            styles.incomeColumnRight,
                        ]}
                    >
                        <View style={styles.tableHeader}>
                            <Text style={styles.tableHeaderTitle}>
                                DEDUCTIONS
                            </Text>

                            <Text style={styles.tableHeaderAmount}>
                                AMOUNT
                            </Text>
                        </View>

                        <View style={styles.tableHeaderLine} />

                        {/* {deductions.map((item, index) => (
                            <View
                                key={`deduction-${index}`}
                                style={styles.salaryRow}
                            >
                                <Text style={styles.salaryDescription}>
                                    {item.description}
                                </Text>

                                <Text style={styles.salaryAmount}>
                                    Rs. {formatAmount(item.amount)}
                                </Text>
                            </View>
                        ))} */}

                        {Array.from({ length: maxSalaryRows }).map((_, index) => {
                            const item = deductions[index];

                            return (
                                <View
                                    key={`deduction-${index}`}
                                    style={styles.salaryRow}
                                >
                                    {item ? (
                                        <>
                                            <Text style={styles.salaryDescription}>
                                                {item.description}
                                            </Text>

                                            <Text style={styles.salaryAmount}>
                                                Rs. {formatAmount(item.amount)}
                                            </Text>
                                        </>
                                    ) : (
                                        <>
                                            <Text style={styles.salaryDescription}>
                                                {" "}
                                            </Text>

                                            <Text style={styles.salaryAmount}>
                                                {" "}
                                            </Text>
                                        </>
                                    )}
                                </View>
                            );
                        })}

                        <View style={styles.totalRowRight}>
                            <Text style={styles.totalText}>
                                Total Deductions
                            </Text>

                            <Text style={styles.totalAmount}>
                                Rs. {formatAmount(data.totalDeductions)}
                            </Text>
                        </View>
                    </View>
                </View>

                {/* ==================================================
                    TOTAL NET PAYABLE
                ================================================== */}

                <View style={styles.totalPayableBox}>
                    <View style={styles.payableLeft}>
                        <Text style={styles.payableTitle}>
                            TOTAL NET PAYABLE
                        </Text>

                        <Text style={styles.payableSubtitle}>
                            Gross Income - Total Deductions
                        </Text>
                    </View>

                    <View style={styles.payableAmount}>
                        <Text>
                            Rs. {formatAmount(data.netSalary)}
                        </Text>
                    </View>
                </View>

                {/* ==================================================
                    AMOUNT IN WORDS
                ================================================== */}

                <Text style={styles.amountWords}>
                    Amount In Words :{" "}

                    <Text style={styles.amountWordsStrong}>
                        {data.amountInWords || "-"}
                    </Text>
                </Text>

                {/* ==================================================
                    FOOTER
                ================================================== */}

                <Text style={styles.footer}>
                    This is a system-generated salary slip from{" "}

                    <Text style={styles.footerStrong}>
                        Kipinn
                    </Text>.
                </Text>
            </Page>
        </Document>
    );
};



// BROWSER PREVIEW


const SalarySlipPreview = ({ data }) => {
    const formattedPayPeriod = data.payPeriod
        ? moment(`${data.payPeriod}-01`).format("MMMM YYYY")
        : "-";

    const formattedPayDate = data.payDate
        ? moment(data.payDate).format("DD/MM/YYYY")
        : "-";

    const earnings =
        data.earnings?.filter((item) => item.description?.trim()) || [];

    const deductions =
        data.deductions?.filter((item) => item.description?.trim()) || [];

    const maxSalaryRows = Math.max(
        earnings.length,
        deductions.length
    );

    const summaryItems = [
        ["Employee Name", data.employeeName || "-"],
        ["Employee ID", data.employeeId || "-"],
        ["Pay Period", formattedPayPeriod],
        ["Pay Date", formattedPayDate],
    ];

    return (
        <div
            style={{
                position: "relative",
                width: "794px",
                height: "1122px",
                padding: "38px 40px 32px",
                boxSizing: "border-box",
                background: "#ffffff",
                color: "#222",
                fontFamily: "Arial, Helvetica, sans-serif",
                overflow: "hidden",
            }}
        >

            {/* ==================================================
                HEADER
            ================================================== */}

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                }}
            >

                {/* COMPANY INFORMATION */}

                <div
                    style={{
                        flex: 1,
                        paddingRight: 15,
                    }}
                >

                    <div
                        style={{
                            maxWidth: 350,
                        }}
                    >

                        {/* COMPANY NAME */}

                        <div
                            style={{
                                fontSize: 21,
                                fontWeight: 700,
                                color: "#303030",
                                lineHeight: 1.15,
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {data.companyName || "Company Name"}
                        </div>


                        {/* COMPANY ADDRESS */}

                        <div
                            style={{
                                marginTop: 6,
                                fontSize: 13,
                                color: "#666",
                                lineHeight: 1.3,
                                overflowWrap: "break-word",
                                wordBreak: "break-word",
                            }}
                        >
                            {data.address || ""}

                            {data.city
                                ? `, ${data.city}`
                                : ""}

                            {data.pincode
                                ? `, ${data.pincode}`
                                : ""}
                        </div>

                    </div>

                </div>


                {/* MONTH */}

                <div
                    style={{
                        width: 150,
                        textAlign: "right",
                    }}
                >

                    <div
                        style={{
                            fontSize: 13,
                            color: "#666",
                        }}
                    >
                        Payslip For the Month
                    </div>

                    <div
                        style={{
                            fontSize: 17,
                            fontWeight: 700,
                            color: "#111",
                            marginTop: 3,
                        }}
                    >
                        {formattedPayPeriod}
                    </div>

                </div>

            </div>


            {/* ==================================================
                HEADER LINE
            ================================================== */}

            <div
                style={{
                    borderTop: "1px solid #bfc5ca",
                    marginTop: 15,
                }}
            />


            {/* ==================================================
                SUMMARY
            ================================================== */}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 285px",
                    gap: 20,
                    marginTop: 18,
                    minHeight: 155,
                }}
            >

                {/* EMPLOYEE SUMMARY */}

                <div
                    style={{
                        paddingTop: 3,
                    }}
                >

                    <div
                        style={{
                            fontSize: 13,
                            fontWeight: 700,
                            color: "#555",
                            marginBottom: 11,
                        }}
                    >
                        EMPLOYEE SUMMARY
                    </div>


                    {summaryItems.map(([label, val], idx) => (

                        <div
                            key={idx}
                            style={{
                                display: "flex",
                                alignItems: "flex-start",
                                marginBottom: 10,
                                minHeight: 19,
                                lineHeight: 1.3,
                            }}
                        >

                            {/* LABEL */}

                            <span
                                style={{
                                    width: 125,
                                    flexShrink: 0,
                                    fontSize: 13,
                                    color: "#666",
                                }}
                            >
                                {label}
                            </span>


                            {/* COLON */}

                            <span
                                style={{
                                    width: 12,
                                    flexShrink: 0,
                                    fontSize: 13,
                                    color: "#666",
                                }}
                            >
                                :
                            </span>


                            {/* VALUE */}

                            <span
                                style={{
                                    flex: 1,
                                    minWidth: 0,
                                    fontSize: 13,
                                    color: "#222",
                                    fontWeight: 500,

                                    overflowWrap: "break-word",
                                    wordBreak: "break-word",
                                    whiteSpace: "normal",
                                }}
                            >
                                {val}
                            </span>

                        </div>

                    ))}

                </div>


                {/* ==================================================
                    NET PAY CARD
                ================================================== */}

                <div
                    style={{
                        border: "1px solid #bcc8d3",
                        borderRadius: 10,
                        overflow: "hidden",
                        height: 155,
                    }}
                >

                    {/* GREEN AREA */}

                    <div
                        style={{
                            display: "flex",
                            padding: "17px 18px 14px",
                            background: "#edfff2",
                            borderRadius: "9px 9px 0 0",
                        }}
                    >

                        <div
                            style={{
                                width: 3,
                                height: 32,
                                borderRadius: 3,
                                background: "#55c96f",
                                marginRight: 10,
                            }}
                        />


                        <div>

                            <div
                                style={{
                                    fontSize: 25,
                                    fontWeight: 500,
                                    lineHeight: 1,
                                    color: "#111",
                                }}
                            >
                                ₹{formatAmount(data.netSalary)}
                            </div>


                            <div
                                style={{
                                    marginTop: 7,
                                    fontSize: 13,
                                    color: "#66836e",
                                }}
                            >
                                Total Net Pay
                            </div>

                        </div>

                    </div>


                    {/* DIVIDER */}

                    <div
                        style={{
                            borderBottom:
                                "1px dotted #c3cbd1",
                            margin: "0 18px",
                        }}
                    />


                    {/* PAID DAYS */}

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "8px 18px 0",
                        }}
                    >

                        <span
                            style={{
                                width: 125,
                                fontSize: 13,
                                color: "#666",
                            }}
                        >
                            Paid Days
                        </span>

                        <span
                            style={{
                                width: 12,
                                fontSize: 13,
                                color: "#666",
                            }}
                        >
                            :
                        </span>

                        <span
                            style={{
                                flex: 1,
                                fontSize: 13,
                                color: "#222",
                                fontWeight: 500,
                            }}
                        >
                            {data.paidDays || 0}
                        </span>

                    </div>


                    {/* LOP DAYS */}

                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "8px 18px 0",
                        }}
                    >

                        <span
                            style={{
                                width: 125,
                                fontSize: 13,
                                color: "#666",
                            }}
                        >
                            LOP Days
                        </span>

                        <span
                            style={{
                                width: 12,
                                fontSize: 13,
                                color: "#666",
                            }}
                        >
                            :
                        </span>

                        <span
                            style={{
                                flex: 1,
                                fontSize: 13,
                                color: "#222",
                                fontWeight: 500,
                            }}
                        >
                            {data.lossOfPayDays || 0}
                        </span>

                    </div>

                </div>

            </div>


            {/* ==================================================
                INCOME / DEDUCTIONS
            ================================================== */}

            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",

                    border: "1px solid #c9d2dc",

                    borderRadius: 10,

                    padding: "13px 12px 0",

                    marginTop: 19,

                    overflow: "hidden",
                }}
            >

                {/* ==================================================
                    INCOME
                ================================================== */}

                <div
                    style={{
                        paddingRight: 10,
                    }}
                >

                    {/* INCOME HEADER */}

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",

                            fontSize: 13,

                            fontWeight: 700,

                            color: "#444",
                        }}
                    >

                        <span>
                            Income
                        </span>

                        <span>
                            AMOUNT
                        </span>

                    </div>


                    {/* LINE */}

                    <div
                        style={{
                            borderBottom:
                                "1px dotted #c5cdd4",

                            margin: "8px 0 2px",
                        }}
                    />


                    {/* EARNINGS */}

                    {Array.from({ length: maxSalaryRows }).map((_, idx) => {
                        const item = earnings[idx];

                        return (
                            <div
                                key={`earning-${idx}`}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    minHeight: 29,
                                    padding: "4px 0",
                                    fontSize: 13,
                                    lineHeight: 1.25,
                                }}
                            >
                                <span
                                    style={{
                                        flex: 1,
                                        minWidth: 0,
                                        paddingRight: 7,
                                        overflowWrap: "break-word",
                                        wordBreak: "break-word",
                                    }}
                                >
                                    {item?.description || "\u00A0"}
                                </span>

                                <span
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "nowrap",
                                        marginLeft: 5,
                                    }}
                                >
                                    {item
                                        ? `₹${formatAmount(item.amount)}`
                                        : "\u00A0"}
                                </span>
                            </div>
                        );
                    })}


                    {/* TOTAL */}

                    <div
                        style={{
                            display: "flex",

                            justifyContent:
                                "space-between",

                            alignItems: "center",

                            background: "#f6f7f9",

                            margin:
                                "5px -10px 0 -12px",

                            padding:
                                "9px 10px 9px 12px",

                            fontSize: 13,

                            fontWeight: 700,

                            borderBottomLeftRadius: 9,
                        }}
                    >

                        <span>
                            Gross Income
                        </span>

                        <span>
                            ₹{formatAmount(
                                data.grossEarnings
                            )}
                        </span>

                    </div>

                </div>


                {/* ==================================================
                    DEDUCTIONS
                ================================================== */}

                <div
                    style={{
                        paddingLeft: 10,
                    }}
                >

                    {/* DEDUCTION HEADER */}

                    <div
                        style={{
                            display: "flex",

                            justifyContent:
                                "space-between",

                            fontSize: 13,

                            fontWeight: 700,

                            color: "#444",
                        }}
                    >

                        <span>
                            DEDUCTIONS
                        </span>

                        <span>
                            AMOUNT
                        </span>

                    </div>


                    {/* LINE */}

                    <div
                        style={{
                            borderBottom:
                                "1px dotted #c5cdd4",

                            margin: "8px 0 2px",
                        }}
                    />


                    {/* DEDUCTIONS */}

                    {Array.from({ length: maxSalaryRows }).map((_, idx) => {
                        const item = deductions[idx];

                        return (
                            <div
                                key={`deduction-${idx}`}
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-start",
                                    minHeight: 29,
                                    padding: "4px 0",
                                    fontSize: 13,
                                    lineHeight: 1.25,
                                }}
                            >
                                <span
                                    style={{
                                        flex: 1,
                                        minWidth: 0,
                                        paddingRight: 7,
                                        overflowWrap: "break-word",
                                        wordBreak: "break-word",
                                    }}
                                >
                                    {item?.description || "\u00A0"}
                                </span>

                                <span
                                    style={{
                                        fontWeight: 600,
                                        whiteSpace: "nowrap",
                                        marginLeft: 5,
                                    }}
                                >
                                    {item
                                        ? `₹${formatAmount(item.amount)}`
                                        : "\u00A0"}
                                </span>
                            </div>
                        );
                    })}


                    {/* TOTAL */}

                    <div
                        style={{
                            display: "flex",

                            justifyContent:
                                "space-between",

                            alignItems: "center",

                            background: "#f6f7f9",

                            margin:
                                "5px -12px 0 -10px",

                            padding:
                                "9px 12px 9px 10px",

                            fontSize: 13,

                            fontWeight: 700,

                            borderBottomRightRadius: 9,
                        }}
                    >

                        <span>
                            Total Deductions
                        </span>

                        <span>
                            ₹{formatAmount(
                                data.totalDeductions
                            )}
                        </span>

                    </div>

                </div>

            </div>


            {/* ==================================================
                TOTAL NET PAYABLE
            ================================================== */}

            <div
                style={{
                    display: "flex",

                    border:
                        "1px solid #c9d2dc",

                    borderRadius: 9,

                    overflow: "hidden",

                    marginTop: 19,

                    minHeight: 55,
                }}
            >

                {/* LEFT */}

                <div
                    style={{
                        flex: 1,

                        padding: "9px 14px",
                    }}
                >

                    <div
                        style={{
                            fontSize: 13,
                            fontWeight: 700,
                        }}
                    >
                        TOTAL NET PAYABLE
                    </div>


                    <div
                        style={{
                            marginTop: 4,
                            fontSize: 11.5,
                            color: "#666",
                        }}
                    >
                        Gross Income - Total Deductions
                    </div>

                </div>


                {/* RIGHT AMOUNT */}

                <div
                    style={{
                        width: 135,

                        display: "flex",

                        alignItems: "center",

                        justifyContent:
                            "center",

                        background: "#edfff2",

                        fontSize: 14,

                        fontWeight: 700,

                        borderTopRightRadius: 8,

                        borderBottomRightRadius: 8,
                    }}
                >
                    ₹{formatAmount(data.netSalary)}
                </div>

            </div>


            {/* ==================================================
                AMOUNT IN WORDS
            ================================================== */}

            <div
                style={{
                    marginTop: 16,

                    textAlign: "right",

                    fontSize: 11.5,

                    color: "#666",

                    lineHeight: 1.3,

                    overflowWrap: "break-word",
                    wordBreak: "break-word",
                }}
            >

                Amount In Words :{" "}

                <strong
                    style={{
                        color: "#111",
                        fontWeight: 500,
                    }}
                >
                    {data.amountInWords || "-"}
                </strong>

            </div>


            {/* ==================================================
                FOOTER
            ================================================== */}

            <div
                style={{
                    position: "absolute",

                    bottom: 15,

                    left: 40,

                    right: 40,

                    paddingTop: 9,

                    borderTop:
                        "1px solid #c0c7cd",

                    textAlign: "center",

                    fontSize: 10,

                    color: "#777",
                }}
            >
                This is a system-generated salary slip from{" "}
                <strong>Kipinn</strong>.
            </div>

        </div>
    );
};


// GENERATED SALARY SLIP


const GeneratedSalarySlip = ({ data }) => {
    if (!data) return null;

    const employeeName =
        data.employeeName
            ?.trim()
            ?.replace(/\s+/g, "-") ||
        "Employee";

    const payPeriod =
        data.payPeriod ||
        "Salary-Slip";

    const printSlip = () => {
        window.print();
    };

    return (
        <div className="generated-slip-wrapper">
            {/* ==================================================
                ACTION BUTTONS
            ================================================== */}

            <div className="generated-slip-actions">
                <button
                    type="button"
                    onClick={printSlip}
                    className="print-slip-button"
                >
                    Print
                </button>

                <PDFDownloadLink
                    document={
                        <SalarySlipPDF data={data} />
                    }
                    fileName={
                        `Salary-Slip-${employeeName}-${payPeriod}.pdf`
                    }
                    className="download-slip-button"
                >
                    {({ loading }) =>
                        loading
                            ? "Generating PDF..."
                            : "Download PDF"
                    }
                </PDFDownloadLink>
            </div>

            {/* ==================================================
                PREVIEW
            ================================================== */}

            <div className="salary-slip-preview">
                <SalarySlipPreview data={data} />
            </div>

            {/* ==================================================
                CSS
            ================================================== */}

            <style>{`
                .generated-slip-wrapper {
                    width: 100%;
                    margin-top: 20px;
                }

                .generated-slip-actions {
                    width: 794px;

                    margin: 0 auto 20px;

                    display: flex;

                    justify-content: center;

                    align-items: center;

                    gap: 12px;
                }

                .print-slip-button {
                    border: 1px solid #d1d5db;

                    background: white;

                    color: #374151;

                    padding: 9px 20px;

                    border-radius: 7px;

                    font-size: 13px;

                    font-weight: 600;

                    cursor: pointer;
                }

                .download-slip-button {
                    border: none;

                    background: #1a365d;

                    color: white;

                    padding: 9px 20px;

                    border-radius: 7px;

                    font-size: 13px;

                    font-weight: 600;

                    cursor: pointer;

                    text-decoration: none;

                    display: inline-flex;

                    align-items: center;

                    justify-content: center;
                }

                .salary-slip-preview {
                    width: 794px;

                    min-height: 1122px;

                    margin: 0 auto;

                    background: white;

                    box-shadow:
                        0 4px 25px
                        rgba(0, 0, 0, 0.10);
                }

                @media print {
                    @page {
                        size: A4;
                        margin: 0;
                    }

                    body {
                        margin: 0 !important;
                        padding: 0 !important;
                        background: white !important;
                    }

                    .generated-slip-actions {
                        display: none !important;
                    }

                    .salary-slip-preview {
                        box-shadow: none !important;
                        margin: 0 !important;
                    }
                }
            `}</style>
        </div>
    );
};

export default GeneratedSalarySlip;





















// import React from "react";
// import moment from "moment";
// import html2pdf from "html2pdf.js";



// // FORMAT NUMBER
// const formatAmount = (amount) => {
//     return (Number(amount) || 0).toLocaleString("en-IN", {
//         minimumFractionDigits: 2,
//         maximumFractionDigits: 2,
//     });
// };


// // GENERATED SALARY SLIP

// const GeneratedSalarySlip = ({ data }) => {

//     if (!data) {
//         return null;
//     }

//     // DOWNLOAD PDF

//     const downloadPDF = () => {
//         const element = document.getElementById("salary-slip-pdf");

//         if (!element) {
//             return;
//         }

//         const employeeName =
//             data.employeeName
//                 ?.trim()
//                 ?.replace(/\s+/g, "-") || "Employee";

//         const payPeriod =
//             data.payPeriod || "Salary-Slip";

//         const options = {
//             margin: 0,

//             filename: `Salary-Slip-${employeeName}-${payPeriod}.pdf`,

//             image: {
//                 type: "jpeg",
//                 quality: 0.98,
//             },

//             html2canvas: {
//                 scale: 2,
//                 useCORS: true,
//                 backgroundColor: "#ffffff",
//                 scrollX: 0,
//                 scrollY: 0,
//             },

//             jsPDF: {
//                 unit: "mm",
//                 format: "a4",
//                 orientation: "portrait",
//             },

//             pagebreak: {
//                 mode: ["css", "legacy"],
//             },
//         };

//         html2pdf()
//             .set(options)
//             .from(element)
//             .save();
//     };



//     // PRINT

//     const printSlip = () => {
//         window.print();
//     };

//     // PAY PERIOD
//     const formattedPayPeriod = data.payPeriod
//         ? moment(
//             `${data.payPeriod}-01`
//         ).format("MMMM YYYY")
//         : "-";



//     // PAY DATE
//     const formattedPayDate = data.payDate
//         ? moment(data.payDate).format(
//             "DD/MM/YYYY"
//         )
//         : "-";


//     return (
//         <div className="generated-slip-wrapper">

//             {/* =================================================
//                 ACTION BUTTONS
//             ================================================== */}

//             <div className="generated-slip-actions">

//                 <button
//                     type="button"
//                     onClick={printSlip}
//                     className="print-slip-button"
//                 >
//                     Print
//                 </button>


//                 <button
//                     type="button"
//                     onClick={downloadPDF}
//                     className="download-slip-button"
//                 >
//                     Download PDF
//                 </button>

//             </div>


//             {/* =================================================
//                 A4 SALARY SLIP
//             ================================================== */}

//             <div
//                 id="salary-slip-pdf"
//                 className="salary-slip-page"
//             >

//                 {/* =================================================
//                     HEADER
//                 ================================================== */}

//                 {/* <div className="slip-header">

//                     <div className="company-info">

//                         <div className="company-name">
//                             {data.companyName || "Company Name"}
//                         </div>

//                         <div className="company-address">
//                             {data.address || ""}

//                             {data.city
//                                 ? `, ${data.city}`
//                                 : ""}

//                             {data.pincode
//                                 ? `, ${data.pincode}`
//                                 : ""}
//                         </div>

//                     </div>

//                     <div className="month-section">

//                         <div className="month-label">
//                             Payslip For the Month
//                         </div>

//                         <div className="month-value">
//                             {formattedPayPeriod}
//                         </div>

//                     </div>

//                 </div> */}
//                 <div className="slip-header">

//                     <div className="company-info">

//                         <div className="company-text">

//                             <div className="company-name">
//                                 {data.companyName || "Company Name"}
//                             </div>

//                             <div className="company-address">
//                                 {data.address || ""}

//                                 {data.city
//                                     ? `, ${data.city}`
//                                     : ""}

//                                 {data.pincode
//                                     ? `, ${data.pincode}`
//                                     : ""}
//                             </div>

//                         </div>

//                     </div>

//                     <div className="month-section">

//                         <div className="month-label">
//                             Payslip For the Month
//                         </div>

//                         <div className="month-value">
//                             {formattedPayPeriod}
//                         </div>

//                     </div>

//                 </div>
//                 <div className="header-line"></div>


//                 {/* =================================================
//                     EMPLOYEE SUMMARY
//                 ================================================== */}

//                 <div className="summary-wrapper">

//                     {/* LEFT SIDE */}

//                     <div className="employee-summary">

//                         <div className="summary-title">
//                             EMPLOYEE SUMMARY
//                         </div>


//                         <div className="summary-row">

//                             <span>
//                                 Employee Name
//                             </span>

//                             <span>:</span>

//                             <strong>
//                                 {data.employeeName ||
//                                     "-"}
//                             </strong>

//                         </div>


//                         <div className="summary-row">

//                             <span>
//                                 Employee ID
//                             </span>

//                             <span>:</span>

//                             <strong>
//                                 {data.employeeId ||
//                                     "-"}
//                             </strong>

//                         </div>


//                         <div className="summary-row">

//                             <span>
//                                 Pay Period
//                             </span>

//                             <span>:</span>

//                             <strong>
//                                 {formattedPayPeriod}
//                             </strong>

//                         </div>


//                         <div className="summary-row">

//                             <span>
//                                 Pay Date
//                             </span>

//                             <span>:</span>

//                             <strong>
//                                 {formattedPayDate}
//                             </strong>

//                         </div>

//                     </div>


//                     {/* RIGHT SIDE - NET PAY */}

//                     <div className="net-pay-card">

//                         <div className="net-pay-main">

//                             <div className="net-pay-border"></div>


//                             <div>

//                                 <div className="net-pay-amount">

//                                     ₹
//                                     {formatAmount(
//                                         data.netSalary
//                                     )}

//                                 </div>


//                                 <div className="net-pay-label">
//                                     Total Net Pay
//                                 </div>

//                             </div>

//                         </div>


//                         <div className="net-pay-divider"></div>


//                         <div className="days-row">

//                             <span>
//                                 Paid Days
//                             </span>

//                             <span>:</span>

//                             <strong>
//                                 {data.paidDays || 0}
//                             </strong>

//                         </div>


//                         <div className="days-row">

//                             <span>
//                                 LOP Days
//                             </span>

//                             <span>:</span>

//                             <strong>
//                                 {data.lossOfPayDays || 0}
//                             </strong>

//                         </div>

//                     </div>

//                 </div>


//                 {/* =================================================
//                     Income + DEDUCTIONS
//                 ================================================== */}

//                 <div className="income-section">


//                     {/* ================= Income ================= */}

//                     <div className="income-column">

//                         <div className="table-header">

//                             <span>
//                                 Income
//                             </span>

//                             <span>
//                                 AMOUNT
//                             </span>

//                         </div>


//                         <div className="table-header-line"></div>


//                         {data.earnings
//                             ?.filter(
//                                 (item) =>
//                                     item.description?.trim()
//                             )
//                             .map(
//                                 (
//                                     item,
//                                     index
//                                 ) => (

//                                     <div
//                                         className="salary-row"
//                                         key={index}
//                                     >

//                                         <span>
//                                             {
//                                                 item.description
//                                             }
//                                         </span>

//                                         <strong>
//                                             ₹
//                                             {formatAmount(
//                                                 item.amount
//                                             )}
//                                         </strong>

//                                     </div>

//                                 )
//                             )}


//                         <div className="total-row">

//                             <strong>
//                                 Gross Income
//                             </strong>

//                             <strong>
//                                 ₹
//                                 {formatAmount(
//                                     data.grossEarnings
//                                 )}
//                             </strong>

//                         </div>

//                     </div>


//                     {/* ================= DEDUCTIONS ================= */}

//                     <div className="income-column">

//                         <div className="table-header">

//                             <span>
//                                 DEDUCTIONS
//                             </span>

//                             <span>
//                                 AMOUNT
//                             </span>

//                         </div>


//                         <div className="table-header-line"></div>


//                         {data.deductions
//                             ?.filter(
//                                 (item) =>
//                                     item.description?.trim()
//                             )
//                             .map(
//                                 (
//                                     item,
//                                     index
//                                 ) => (

//                                     <div
//                                         className="salary-row"
//                                         key={index}
//                                     >

//                                         <span>
//                                             {
//                                                 item.description
//                                             }
//                                         </span>

//                                         <strong>
//                                             ₹
//                                             {formatAmount(
//                                                 item.amount
//                                             )}
//                                         </strong>

//                                     </div>

//                                 )
//                             )}


//                         <div className="total-row">

//                             <strong>
//                                 Total Deductions
//                             </strong>

//                             <strong>
//                                 ₹
//                                 {formatAmount(
//                                     data.totalDeductions
//                                 )}
//                             </strong>

//                         </div>

//                     </div>

//                 </div>


//                 {/* =================================================
//                     TOTAL NET PAYABLE
//                 ================================================== */}

//                 <div className="total-payable-box">

//                     <div>

//                         <div className="payable-title">
//                             TOTAL NET PAYABLE
//                         </div>


//                         <div className="payable-subtitle">
//                             Gross Income - Total Deductions
//                         </div>

//                     </div>


//                     <div className="payable-amount">

//                         ₹
//                         {formatAmount(
//                             data.netSalary
//                         )}

//                     </div>

//                 </div>


//                 {/* =================================================
//                     AMOUNT IN WORDS
//                 ================================================== */}

//                 <div className="amount-words">

//                     Amount In Words : <strong>{data.amountInWords}</strong>

//                 </div>


//                 {/* =================================================
//                     FOOTER
//                 ================================================== */}


//                 <div className="slip-footer">
//                     This is a system-generated salary slip from <strong>Kipinn</strong>.
//                 </div>

//             </div>


//             {/* =================================================
//                 CSS
//             ================================================== */}

//             <style>{`

//                 /* =========================================
//                    WRAPPER
//                 ========================================== */

//                 .generated-slip-wrapper {
//                     width: 100%;
//                     margin-top: 20px;
//                 }


//                 /* =========================================
//                    BUTTONS
//                 ========================================== */

//                 .generated-slip-actions {
//                     width: 794px;
//                     margin: 0 auto 20px;
//                     display: flex;
//                     justify-content: center;
//                     align-items: center;
//                     gap: 12px;
//                  }


//                 .print-slip-button {
//                     border: 1px solid #d1d5db;
//                     background: white;
//                     color: #374151;
//                     padding: 10px 22px;
//                     border-radius: 7px;
//                     font-size: 14px;
//                     font-weight: 600;
//                     cursor: pointer;
//                 }


//                 .print-slip-button:hover {
//                     background: #f9fafb;
//                 }


//                 .download-slip-button {
//                     border: none;
//                     background: #1a365d;
//                     color: white;
//                     padding: 10px 22px;
//                     border-radius: 7px;
//                     font-size: 14px;
//                     font-weight: 600;
//                     cursor: pointer;
//                 }


//                 .download-slip-button:hover {
//                     background: #13294b;
//                 }


//                 /* =========================================
//                    A4 PAGE
//                 ========================================== */

//                 .salary-slip-page {
//                     position: relative;

//                     width: 794px;
//                     height: 1122px;
//                     min-height: 1122px;
//                     max-height: 1122px;

//                     margin: 0 auto;

//                     padding: 48px 48px 35px 48px;

//                     background: white;

//                     color: #222;

//                     font-family:
//                         Arial,
//                         Helvetica,
//                         sans-serif;

//                     box-sizing: border-box;

//                     overflow: hidden;

//                     box-shadow:
//                         0 4px 25px
//                         rgba(0, 0, 0, 0.10);
//                 }


//                 /* =========================================
//                    HEADER
//                 ========================================== */

//                 .slip-header {
//                     display: flex;
//                     align-items: flex-start;
//                     justify-content: space-between;
//                     gap: 30px;
//                 }

//                 .company-info {
//                     flex: 1;
//                     min-width: 0;
//                     padding-right: 10px;
//                 }

//                 .company-text {
//                     max-width: 370px;
//                 }

//                 .company-name {
//                     font-size: 20px;
//                     font-weight: 700;
//                     color: #303030;
//                     line-height: 1.2;

//                     white-space: normal;
//                     overflow-wrap: break-word;
//                     word-break: break-word;
//                 }

//                 .company-address {
//                     margin-top: 5px;
//                     font-size: 13px;
//                     color: #666;
//                     line-height: 1.4;

//                     white-space: normal;
//                     overflow-wrap: break-word;
//                     word-break: break-word;
//                 }

//                 .month-section {
//                     width: 150px;
//                     min-width: 150px;
//                     flex-shrink: 0;
//                     text-align: right;
//                 }

//                 .month-label {
//                     font-size: 15px;
//                     color: #666;
//                     margin-bottom: 0px;
//                 }


//                 .month-value {
//                     font-size: 19px;
//                     font-weight: 700;
//                     color: #111;
//                 }


//                 .header-line {
//                     margin-top: 17px;
//                     border-top: 1px solid #bfc5ca;
//                 }


//                 /* =========================================
//                    EMPLOYEE SUMMARY
//                 ========================================== */

//                 .summary-wrapper {
//                     display: grid;
//                     grid-template-columns:
//                         1fr
//                         340px;

//                     gap: 25px;

//                     margin-top: 20px;

//                     min-height: 205px;
//                 }


//                 .employee-summary {
//                     padding-top: 7px;
//                 }


//                 .summary-title {
//                     font-size: 14px;
//                     font-weight: 700;
//                     color: #555;
//                     margin-bottom: 12px;
//                 }


//                 // .summary-row {
//                 //     display: grid;

//                 //     grid-template-columns:
//                 //         170px
//                 //         15px
//                 //         1fr;

//                 //     align-items: center;

//                 //     margin-bottom: 13px;

//                 //     font-size: 15px;

//                 //     color: #666;
//                 // }


//                 // .summary-row strong {
//                 //     font-weight: 500;
//                 //     color: #222;
//                 // }

//                 .summary-row {
//                     display: grid;
//                     grid-template-columns: 150px 15px 1fr; /* Adjusted label width slightly to give text more space */
//                     align-items: baseline;                 /* Align colon & text with top line */
//                     margin-bottom: 13px;
//                     font-size: 15px;
//                     color: #666;
//                 }

//                 .summary-row strong {
//                     font-weight: 500;
//                     color: #222;
//                     overflow-wrap: break-word;
//                     word-break: break-word;
//                 }


//                 /* =========================================
//                    NET PAY CARD
//                 ========================================== */

//                 .net-pay-card {
//                     border:
//                         1px solid
//                         #bcc8d3;

//                     border-radius: 14px;

//                     overflow: hidden;

//                     height: 205px;
//                 }


//                 .net-pay-main {
//                     display: flex;

//                     padding:
//                         23px
//                         25px
//                         20px;

//                     background: #edfff2;
//                 }


//                 .net-pay-border {
//                     width: 4px;

//                     border-radius: 4px;

//                     background: #55c96f;

//                     margin-right: 12px;
//                 }


//                 .net-pay-amount {
//                     font-size: 29px;

//                     font-weight: 500;

//                     line-height: 1;

//                     color: #111;
//                 }


//                 .net-pay-label {
//                     margin-top: 8px;

//                     font-size: 15px;

//                     color: #66836e;
//                 }


//                 .net-pay-divider {
//                     border-top:
//                         2px dotted
//                         #c3cbd1;

//                     margin:
//                         0
//                         25px;
//                 }


//                 .days-row {
//                     display: grid;

//                     grid-template-columns:
//                         160px
//                         15px
//                         1fr;

//                     padding:
//                         8px
//                         25px
//                         0;

//                     font-size: 14px;

//                     color: #666;
//                 }


//                 .days-row strong {
//                     color: #222;
//                     font-weight: 500;
//                 }


//                 /* =========================================
//                    Income / DEDUCTIONS
//                 ========================================== */

//                 .income-section {
//                     display: grid;

//                     grid-template-columns:
//                         1fr
//                         1fr;

//                     gap: 30px;

//                     border:
//                         1px solid
//                         #c9d2dc;

//                     border-radius: 13px;

//                     padding: 18px;

//                     margin-top: 28px;

//                     overflow: hidden;
//                 }


//                 .income-column {
//                     min-width: 0;
//                     display: flex;
//                     flex-direction: column;
//                     height: 100%;
//                 }


//                 .table-header {
//                     display: flex;

//                     justify-content:
//                         space-between;

//                     font-size: 14px;

//                     font-weight: 700;

//                     color: #444;
//                 }


//                 .table-header-line {
//                     border-top:
//                         2px dotted
//                         #c5cdd4;

//                     margin-top: 11px;

//                     margin-bottom: 2px;
//                 }


//                 .salary-row {
//                     display: flex;

//                     justify-content:
//                         space-between;

//                     align-items: center;

//                     min-height: 41px;

//                     font-size: 14px;

//                     color: #222;
//                 }


//                 .salary-row strong {
//                     font-weight: 600;

//                     white-space: nowrap;
//                 }


//                 .total-row {
//                     display: flex;
//                     justify-content: space-between;
//                     align-items: center;

//                     margin-top: auto;

//                     margin-left: -18px;
//                     margin-right: -18px;
//                     margin-bottom: -18px;

//                     padding: 11px 18px;

//                     background: #f6f7f9;

//                     font-size: 14px;
//                 }


//                 /* =========================================
//                    TOTAL PAYABLE
//                 ========================================== */

//                 .total-payable-box {
//                     display: grid;

//                     grid-template-columns:
//                         1fr
//                         138px;

//                     border:
//                         1px solid
//                         #c9d2dc;

//                     border-radius: 12px;

//                     overflow: hidden;

//                     margin-top: 37px;
//                 }


//                 .payable-title {
//                     padding:
//                         12px
//                         18px
//                         0;

//                     font-size: 14px;

//                     font-weight: 700;

//                     color: #222;
//                 }


//                 .payable-subtitle {
//                     padding:
//                         3px
//                         18px
//                         13px;

//                     color: #666;

//                     font-size: 13px;
//                 }


//                 .payable-amount {
//                     display: flex;

//                     align-items: center;

//                     justify-content: center;

//                     background: #edfff2;

//                     font-size: 16px;

//                     font-weight: 700;

//                     color: #111;
//                 }


//                 /* =========================================
//                    AMOUNT WORDS
//                 ========================================== */

//                 .amount-words {
//                     margin-top: 25px;

//                     text-align: right;

//                     font-size: 13px;

//                     color: #666;
//                 }


//                 .amount-words strong {
//                     color: #111;

//                     font-weight: 500;
//                 }


//                 /* =========================================
//                    FOOTER
//                 ========================================== */


//                 .slip-footer {
//                     position: absolute;
//                     bottom: 20px;
//                     left: 48px;
//                     right: 48px;

//                     text-align: center;

//                     padding-top: 12px;

//                     border-top: 1px solid #c0c7cd;

//                     font-size: 11px;
//                     color: #777;
//                 }


//                 /* =========================================
//                    PRINT
//                 ========================================== */

//                 @media print {

//                     @page {
//                         size: A4;
//                         margin: 0;
//                     }


//                     body {
//                         margin: 0 !important;
//                         padding: 0 !important;
//                         background: white !important;
//                     }


//                     body * {
//                         visibility: hidden;
//                     }


//                     #salary-slip-pdf,
//                     #salary-slip-pdf * {
//                         visibility: visible;
//                     }


//                     #salary-slip-pdf {
//                         position: absolute;

//                         left: 0;
//                         top: 0;

//                         width: 794px !important;

//                         min-height:
//                             1123px !important;

//                         margin: 0 !important;

//                         box-shadow: none !important;
//                     }


//                     .generated-slip-actions {
//                         display: none !important;
//                     }

//                 }

//             `}</style>

//         </div>
//     );
// };


// export default GeneratedSalarySlip;